import React, { useCallback, useState } from "react";
import ModalNotification, { NotificationType } from "../components/modal-notification";

export interface UseModalNotificationReturn {
  showError: (message: string | React.ReactNode, title?: string) => void;
  showWarning: (message: string | React.ReactNode, title?: string) => void;
  showInfo: (message: string | React.ReactNode, title?: string) => void;
  ModalNotificationComponent: React.ReactNode;
}

export const useModalNotification = (): UseModalNotificationReturn => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<NotificationType>("error");
  const [title, setTitle] = useState<string>("");
  const [message, setMessage] = useState<string | React.ReactNode>("");

  const showError = useCallback((msg: string | React.ReactNode, ttl?: string) => {
    setType("error");
    setTitle(ttl || "Lỗi");
    setMessage(msg);
    setOpen(true);
  }, []);

  const showWarning = useCallback((msg: string | React.ReactNode, ttl?: string) => {
    setType("warning");
    setTitle(ttl || "Cảnh báo");
    setMessage(msg);
    setOpen(true);
  }, []);

  const showInfo = useCallback((msg: string | React.ReactNode, ttl?: string) => {
    setType("info");
    setTitle(ttl || "Thông báo");
    setMessage(msg);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const ModalNotificationComponent = (
    <ModalNotification
      open={open}
      type={type}
      title={title}
      message={message}
      onOk={handleClose}
      onCancel={handleClose}
      showCancel={false}
      okText="Đóng"
    />
  );

  return {
    showError,
    showWarning,
    showInfo,
    ModalNotificationComponent,
  };
};

export default useModalNotification;
